import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    fetchLiquidacionporid,
    fetchLiquidacionporidOrdenes,
    fetchLiquidacionporidNovedades,
    fetchLiquidacionporidLogistica
} from '../../../../actions/LiquidacionesActions';
import { putEditaLiquidacion } from '../../../../api/axios.js';
import DetalleLiquidacionEditar from './DetalleLiquidacionEditar';
import OrdenesDeLiquidacionBorrador from './OrdenesDeLiquidacionBorrador';
import NovedadesDeLiquidacionBorrador from './NovedadesDeLiquidacionBorrador';
import LogisticaDeLiquidacion from './LogisticaDeLiquidacion';
import RebatesDeLiquidacion from "./RebatesDeLiquidacion";
import GoBackArrow from '../../../General/GoBackArrow';
import { toast } from 'react-toastify';

class EditarLiquidacionBorrador extends Component {
    constructor(props) {
        super(props);
        this.idOrdenesSeleccionadas = React.createRef();
        this.idNovedadesSeleccionadas = React.createRef();
        this.state = {
            request: {
                idLiquidacion: parseInt(this.props.match.params.id),
                idSeller: parseInt(this.props.match.params.idSeller),
                borrador: 1
            }
        }
    };

    componentDidMount() {
        this.props.fetchLiquidacionporid(this.state.request);
        this.props.fetchLiquidacionporidOrdenes(this.state.request);
        this.props.fetchLiquidacionporidNovedades(this.state.request);
        this.props.fetchLiquidacionporidLogistica(this.state.request);
    }

    confirmarLiquidacion = async (event) => {

        event.preventDefault();

        let idOrdenes = this.idOrdenesSeleccionadas
            .current
            .state
            .ordenes
            .filter(x => x.checked === true)
            .map(x => x.idOrden)
            ;

        if (idOrdenes.length === 0) {
            toast.warn("Selecione alguna orden. No puede crear una liquidacion sin orden");
            return;
        }

        let idNovedades = this.idNovedadesSeleccionadas
            .current
            .state
            .novedades
            .filter(x => x.checked === true)
            .map(x => x.idNovedad)
            ;

        let data = {
            CuerpoOrdenes: idOrdenes,
            CuerpoNovedad: idNovedades,
            IdLiquidacion: this.state.request.idLiquidacion,
            IdEstado: 3
        }

        let post = putEditaLiquidacion(data);

        post.then(res => {
            toast.success("La liquidacion fue actualizada con éxito.");
            this.props.history.push(`/Liquidaciones`);
        }).catch(err => {
            toast.error("No pudimos actualizar la liquidación");
        });
    }

    editarBorrador = async (event) => {

        event.preventDefault();

        let idOrdenes = this.idOrdenesSeleccionadas
            .current
            .state
            .ordenes
            .filter(x => x.checked === true)
            .map(x => x.idOrden)
            ;

        if (idOrdenes.length === 0) {
            toast.warn("Selecione alguna orden. No puede crear una liquidacion sin orden");
            return;
        }

        let idNovedades = this.idNovedadesSeleccionadas
            .current
            .state
            .novedades
            .filter(x => x.checked === true)
            .map(x => x.idNovedad)
            ;

        let data = {
            CuerpoOrdenes: idOrdenes,
            CuerpoNovedad: idNovedades,
            IdLiquidacion: this.state.request.idLiquidacion,
            IdEstado: 2
        }

        let post = putEditaLiquidacion(data);

        post.then(res => {
            toast.success("La liquidacion fue actualizada con éxito.");
            this.props.history.push(`/Liquidaciones`);
            return;
        }).catch(err => {
            toast.error("No pudimos actualizar la liquidación");
        });
    }


    render() {

        return (
            <div className="container">

                <div>
                    <input type="hidden" id="valores_ordenes_editar"></input>
                    <input type="hidden" id="valores_novedades_editar"></input>
                </div>

                <DetalleLiquidacionEditar
                    liquidacion={this.props.liquidacion_por_id}
                    isBorrador={true}
                />

                <div className="row justify-content-center align-items-center my-4">

                    <div className="col-12 col-sm-auto">
                        <GoBackArrow />
                    </div>


                    <div className="col-12 col-sm-auto">
                        <form
                            className="form-horizontal form-material"
                            onSubmit={this.confirmarLiquidacion}
                        >
                            <button
                                id="botonLiquidada"
                                type="submit"
                                className="btn btn-sm background-rojo-megatone"
                            >
                                Confirmar Liquidacion
                            </button>
                        </form>
                    </div>

                    <div className="col-12 col-sm-auto">
                        <form
                            className="form-horizontal form-material"
                            onSubmit={this.editarBorrador}
                        >
                            <button
                                id="botonBorrador"
                                type="submit"
                                className="btn btn-sm background-rojo-megatone"
                            >
                                Guardar Borrador
                            </button>
                        </form>
                    </div>

                </div>

                <OrdenesDeLiquidacionBorrador
                    isLoading={this.props.isLoadingOrdenes}
                    ordenes={this.props.liquidacion_por_id_ordenes}
                    ref={this.idOrdenesSeleccionadas}
                />

                <NovedadesDeLiquidacionBorrador
                    isLoading={this.props.isLoadingNovedades}
                    novedades={this.props.liquidacion_por_id_novedades}
                    ref={this.idNovedadesSeleccionadas}
                />

                <LogisticaDeLiquidacion
                    isLoading={this.props.isLoadingLogistica}
                    logistica={this.props.liquidacion_por_id_logistica}
                />

                <RebatesDeLiquidacion idLiquidacion={this.state.request.idLiquidacion} />

            </div>
        );
    }
}


const mapStateToProps = state => ({
    tipoUsuario: state.general.tipoUsuario,
    isLoadingOrdenes: state.liquidaciones.isLoadingOrdenesLiquidacion,
    isLoadingNovedades: state.liquidaciones.isLoadingNovedadesLiquidacion,
    isLoadingLogistica: state.liquidaciones.isLoadingLogisticaLiquidacion,
    liquidacion_por_id: state.liquidaciones.liquidacion_por_id,
    liquidacion_por_id_ordenes: state.liquidaciones.liquidacion_por_id_ordenes,
    liquidacion_por_id_novedades: state.liquidaciones.liquidacion_por_id_novedades,
    liquidacion_por_id_logistica: state.liquidaciones.liquidacion_por_id_logistica
});

export default connect(mapStateToProps, {
    fetchLiquidacionporid,
    fetchLiquidacionporidOrdenes,
    fetchLiquidacionporidNovedades,
    fetchLiquidacionporidLogistica
})(EditarLiquidacionBorrador);